import { APP_STORE_URL } from '@/seo/schema/constants';

/**
 * App Store Connect provider token (App Analytics > Campaigns > Generate a Campaign Link, the `pt=` value).
 * Read off ASC on October 31, 2026. With it, ASC's Campaign column attributes installs to `ct=`.
 */
export const APP_STORE_PROVIDER_TOKEN = '119028389';

/** Where on the site an App Store link sits; becomes `ct=` in App Store Connect. */
export type AppStorePlacement = 'footer' | 'result_card' | 'dashboard_card';

export function appStoreLink(placement: AppStorePlacement): string {
  const params = new URLSearchParams();
  if (APP_STORE_PROVIDER_TOKEN) params.set('pt', APP_STORE_PROVIDER_TOKEN);
  params.set('ct', placement);
  params.set('mt', '8');
  return `${APP_STORE_URL}?${params}`;
}
